
import { Component, OnInit, Injector, ViewChild, Injectable, ElementRef } from '@angular/core';
import { AlertService } from 'src/app/Common/alert.service';
import { UntypedFormGroup, FormArray, UntypedFormBuilder, Validators, NgForm, ValidationErrors } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { MatPaginator as MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { HTTPStatus } from 'src/app/Common/app-token-handler';
import { AppErrorHandler } from 'src/app/Common/app-error-handler';
import { DataService } from 'src/app/Common/data.service';
import { Global } from 'src/app/Global';
import * as XLSX from 'xlsx';
import { CommonService } from 'src/app/shared/common.service';
import saveAs from 'file-saver';


@Component({
  selector: 'app-category-master',
  templateUrl: './category-master.component.html',
  styleUrls: ['./category-master.component.scss'],
  providers: [DataService]
})
export class CategoryMasterComponent implements OnInit {
  CategoryMasterForm: UntypedFormGroup;
  roleList: any;
  selectedItems: [];
  dropdownSetting: {};
  dropdownList: [];
  viewdata: any;
  CategoryDataSource: any[];
  cols: any[];
  Ispanelshow: boolean = false;
  IsAddpanelshow: boolean = false;
  statusList: any;
  IsLoadingResults = false;


  displayedColumns = ['CategoryName', 'EmployeeGPN', 'EmployeeName', 'Status', 'Edit'];
  ResumeDataSource: MatTableDataSource<any[]>;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  recordsExists: boolean = false;
  selectedDefault: any;
  @ViewChild('TABLE', { static: true }) table: ElementRef;
  public show: boolean = false;
  groupList: any;
  requesterList: any;
  filterList: any;



  constructor(private _fb: UntypedFormBuilder, private _router: Router, private error: AppErrorHandler,
    private _activeRoute: ActivatedRoute,
    injector: Injector, private _dialog: MatDialog,
    private status: HTTPStatus, public pcommonService: CommonService, public _dataservice: DataService, public _global: Global, public _com: CommonService) { }


  ngOnInit() {
    this.paginator.showFirstLastButtons = true;
    this.paginator.pageSize = this._global.RecordSize;
    this.CategoryMasterForm = this._fb.group({
      selectedroles: [[],],
      CategoryId: [''],
      EmployeeGPN: [''],
      CategoryName: ['',],
      AccessItemCode: [''],
      AccessItemDisplayName: [''],
      PageNumber: (this._global.pageIndex),
      PageSize: (this._global.RecordSize),
      IsActive: [''],
      AddCategoryName: ['', Validators.required],
      Category: ['', Validators.required],
      EmpName: ['', Validators.required],
      RequesterName: [''],
      RequesterGPN: [''],
      Id: [''],
      StatusSearch: [''],
      CustomerSearch: [''],
      EmpGPN: [''],
      ToolTip:[''],
      //  Role: [, [Validators.required]]
    });
    //this.roleList = [ {name: 'New York', code: 'NY', inactive: false}, {name: 'Rome', code: 'RM', inactive: true}, {name: 'London', code: 'LDN', inactive: false}, {name: 'Istanbul', code: 'IST', inactive: true}, {name: 'Paris', code: 'PRS', inactive: false} ];
    this.BindCategoryList();
    this.SearchRecord();

    this.BindStatusList();


  }

  showhideAdd() {
    this.IsAddpanelshow = !this.IsAddpanelshow;
  }

  showhide() {
    this.Ispanelshow = !this.Ispanelshow;
  }
  // Updated By ANMOL KAUR
  // BindStatusList() {
  //   debugger;
  //   this.pcommonService.BindDropDown('StatusList').subscribe(result => {
  //     this.statusList = result;
  //   }, error => {
  //     this.error.handleError(error);
  //   });
  // }
  BindStatusList() {
    //debugger
    this._dataservice.GetData('Category/GetStatus/').subscribe((result) => {
      this.statusList = result;
      console.log(this.statusList,'BindStatusList');
    });
  }
  BindCategoryList() {

    this.pcommonService.BindDropDown('CategoryWithRole').subscribe(result => {
      this.groupList = result;
    });
  }

  SearchRecord() {
    debugger;
    this._global.pageIndex = 0;
    this._global.length = 0;
    this._global.totalPage = 0;
    this._global.RecordSize = 10;
    this.ViewCategoryList();
  }

  toggle() {
    this.show = !this.show;
  }

  ViewCategoryList() {

    //debugger;
    this.CategoryMasterForm.controls.PageNumber.setValue(this._global.pageIndex + 1);
    this.CategoryMasterForm.controls.PageSize.setValue(this._global.RecordSize);
    
    
   
   //added by anmol kaur for search param
   
   this.CategoryMasterForm.controls.EmpName.setValue('');
   
   let statusid =null;
    if(this.CategoryMasterForm.controls.StatusSearch != undefined && 
      this.CategoryMasterForm.controls.StatusSearch != null && 
      this.CategoryMasterForm.controls.StatusSearch.value != undefined && 
      this.CategoryMasterForm.controls.StatusSearch.value != null){
      statusid = this.CategoryMasterForm.controls.StatusSearch.value.KeywordValue;
    }
    
   
    debugger;

    this.CategoryMasterForm.patchValue({
      
      
      EmpGPN: this.CategoryMasterForm.controls.CustomerSearch.value.EmployeeGPN,
      IsActive: statusid,
      
    });
    
    this._dataservice.PostData('Category/GetCategoryList/', this.CategoryMasterForm.value).subscribe(result => {
      this.viewdata = result;
      if (this.viewdata != null && this.viewdata.length > 0) {

        debugger;
        this.CategoryDataSource = this.viewdata;
        this._global.length = this.viewdata[0].totalrecordcount;
        this._global.totalPage = Math.ceil(this._global.length / this.paginator.pageSize);
      } else {
        this.CategoryDataSource = this.viewdata;
        this._global.length = 0;
        this.paginator.pageSize = this._global.RecordSize;
        this._global.pageIndex = 0;
        this._global.totalPage = 0;
      }
    });
  }

  onPaginateChange1(event) {
    this._global.pageIndex = event.pageIndex;
    this._global.RecordSize = event.pageSize;
    this.ViewCategoryList();
  }

  Relod() {
    window.location.reload();
  }




  showErrorsOnInvalidForm() {
    Object.keys(this.CategoryMasterForm.controls).forEach((field: any) => {
      const control = this.CategoryMasterForm.get(field)!;
      control.markAsTouched({ onlySelf: true });
  
  
      const controlErrors: ValidationErrors = this.CategoryMasterForm.get(field)!.errors!;
      if (controlErrors != null) {
        Object.keys(controlErrors).forEach(keyError => {
         console.log('Key control: ' + field + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });
  }

  GetFormControls(controlName) {
    return this.CategoryMasterForm.controls[controlName];
  }



  Clear() {
    this.CategoryMasterForm.controls.AddCategoryName.setValue('');
    this.CategoryMasterForm.controls.Category.setValue('');
    this.CategoryMasterForm.controls.EmpName.setValue('');
    this.CategoryMasterForm.patchValue({
      Id: 0
    });
    this.GetFormControls('AddCategoryName').clearValidators();
    this.GetFormControls('ToolTip').clearValidators();
this.GetFormControls('Category').clearValidators();
this.GetFormControls('EmpName').clearValidators();
this.GetFormControls('AddCategoryName').updateValueAndValidity();
this.GetFormControls('ToolTip').updateValueAndValidity();
this.GetFormControls('Category').updateValueAndValidity();
    this.GetFormControls('EmpName').updateValueAndValidity();
  }

  Export() {
    this.status.setHttpStatus(true);
    this._com.ExportData(this.CategoryMasterForm.value).subscribe(x => {
      const blob = new Blob([x], { type: 'application/octet-stream' });
      saveAs(blob, 'Category_Master.xls');
    }, (error) => {
      this.status.setHttpStatus(false);
      this.error.handleError(error);
    },
      () => { this.status.setHttpStatus(false); });
  }

  SearchActiveEmployee = (event) => {

    this.pcommonService.Autocomplete('FillCommonData/GetActiveEmployee', event.query).subscribe(result => {
      this.requesterList = this.filterDataList(event.query, result);

    }, (error) => {
      this.error.handleError(error);
    }, () => {
    });
  }
  filterDataList(query, dataList: any): any[] {
    const filtered: any[] = [];
    for (let i = 0; i < dataList.length; i++) {
      this.filterList = dataList[i];
      if (this.filterList.EmployeeName.toLowerCase().indexOf(query.toLowerCase()) === 0) {
        filtered.push(this.filterList);
      }
    }
    return filtered;
  }

  SetEmployeeDetails(event) {

    //ELEMENT_DATA.push({EmployeeGPN: event.EmployeeGPN, EmployeeName: event.EmpName, GroupName: this.AssigmentForm.controls.Group.value.GroupName, GroupId:this.AssigmentForm.controls.Group.value.GroupId})
    //this.AssigmentDataSource = new MatTableDataSource(ELEMENT_DATA);
    RequesterName: event.EmpName;
    RequesterGPN: event.EmployeeGPN;

  }



  clearAutoComplete(controlName) {

    this.CategoryMasterForm.controls.RequesterGPN.reset();
    this.CategoryMasterForm.controls.RequesterName.reset();
  }

  statusupdatedata(element) {
    if (confirm('Are you sure to want update status this record?')) {
      this.CategoryMasterForm.patchValue({
        CategoryId: 1,
        Id: element,
      });
      this.status.setHttpStatus(true);
      this._dataservice.PostData('Category/AddCategoryData/', this.CategoryMasterForm.value).subscribe(result => {
        alert(result[0].MSG);
        if (result[0].STATUS == 0) {
          this.Clear();
          this.SearchRecord();
        }
      }
        , (error) => {
          this.status.setHttpStatus(false);
          this.error.handleError(error);
        },
        () => { this.status.setHttpStatus(false); });
    }
  }

  addcategory() {
    this.GetFormControls('ToolTip').clearValidators();
    this.GetFormControls('ToolTip').updateValueAndValidity
    this.GetFormControls('Category').clearValidators();
    this.GetFormControls('Category').updateValueAndValidity();
    this.GetFormControls('EmpName').clearValidators();
    this.GetFormControls('EmpName').updateValueAndValidity();
    this.GetFormControls('AddCategoryName').setValidators([Validators.required]);
    this.GetFormControls('AddCategoryName').updateValueAndValidity();
    if (!this.CategoryMasterForm.valid) {
      alert('Please fill Category Name');
      this.showErrorsOnInvalidForm();
      return false;
    }
    this.GetFormControls('Category').setValidators([Validators.required]);
    this.GetFormControls('Category').updateValueAndValidity();
    this.GetFormControls('EmpName').setValidators([Validators.required]);
    this.GetFormControls('EmpName').updateValueAndValidity();
    this.GetFormControls('ToolTip').setValidators([Validators.required]);
    this.GetFormControls('ToolTip').updateValueAndValidity();

    this.status.setHttpStatus(true);
    this._dataservice.PostData('Category/SaveCategoryName/', { 'AddCategoryName': this.CategoryMasterForm.controls.AddCategoryName.value , 'ToolTip': this.CategoryMasterForm.controls.ToolTip.value }).subscribe(result => {
      alert(result[0].MSG);
      if (result[0].STATUS == 0) {
        this.CategoryMasterForm.controls.AddCategoryName.setValue('');
        this.toggle();
        this.Clear();
        this.BindCategoryList();
        this.GetFormControls('AddCategoryName').clearValidators();
        this.GetFormControls('AddCategoryName').updateValueAndValidity();
        this.GetFormControls('ToolTip').clearValidators();
        this.GetFormControls('ToolTip').updateValueAndValidity();

      }

    }
      , (error) => {
        this.status.setHttpStatus(false);
        this.error.handleError(error);
      },
      () => { this.status.setHttpStatus(false); });
  }


  Adddata() {
    this.GetFormControls('AddCategoryName').clearValidators();
    this.GetFormControls('AddCategoryName').updateValueAndValidity();
    this.GetFormControls('Category').setValidators([Validators.required]);
    this.GetFormControls('Category').updateValueAndValidity();
    this.GetFormControls('EmpName').setValidators([Validators.required]);
    this.GetFormControls('EmpName').updateValueAndValidity();

    if (!this.CategoryMasterForm.valid) {
      alert('Please fill mandatory fields.');
      this.showErrorsOnInvalidForm();

      return false;
    }
    this.GetFormControls('AddCategoryName').setValidators([Validators.required]);
    this.GetFormControls('AddCategoryName').updateValueAndValidity();

    this.status.setHttpStatus(true);
    this.CategoryMasterForm.patchValue({
      // Assigment:this.AssigmentForm.controls.Assigment.value.data,
      CategoryId: this.CategoryMasterForm.controls.Category.value.value,
      EmployeeGPN: this.CategoryMasterForm.controls.EmpName.value.EmployeeGPN,
    });
    this._dataservice.PostData('Category/AddCategoryData/', this.CategoryMasterForm.value).subscribe(result => {
      alert(result[0].MSG);
      if (result[0].STATUS == 0) {
        this.SearchRecord();
        this.Clear();
        this.GetFormControls('Category').clearValidators();
        this.GetFormControls('Category').updateValueAndValidity();
        this.GetFormControls('EmpName').clearValidators();
        this.GetFormControls('EmpName').updateValueAndValidity();
      }

    }
      , (error) => {
        this.status.setHttpStatus(false);
        this.error.handleError(error);
      },
      () => {
        this.status.setHttpStatus(false);
      });
  }

  //added by anmol kaur
  ResetData() {
    this.CategoryMasterForm.reset({
      CustomerSearch: "",
      StatusSearch: "",
    });
    this.GetResult();
  }

  //added by anmol kaur
  Exit() {
    if (this.CategoryMasterForm.valid) {
      if (confirm("Are you sure you want to exit without saving changes?")) {
        //this.router.navigate(['dashboard']);
        window.history.back();
      }
    } else {
      if (confirm("Are you sure to exit?")) {
        //this.router.navigate(['dashboard']);
        window.history.back();
      }
    }
  }
  //added by anmol kaur
  GetResult() {
    this.SearchRecord();
  }


}
